import React from "react";
import MainLayout from "../components/MainLayout";
import styled from "styled-components";
import Bredcrumb from "../components/Bredcrumb";
import MetaverseContent from "../components/MetaversePages/MetaverseContent";
import CustomHelmet from "../components/CustomHelmet";
const HomeScreen = styled.div``;

const Metaverse = () => {
  return (
    <>
      <CustomHelmet
        title="Revolutionizing Online Education with the Metaverse | Arcaptor"
        description="Transforming online learning with the metaverse, we create holistic, engaging, and inclusive platforms where students thrive academically, socially, and emotionally."
      />
      <MainLayout>
        <HomeScreen>
          <Bredcrumb
            heading="Bridging the gap between online and offline, we deliver seamless integration for a connected experience."
            subHeading="#AlphaRegimentCampus"
            subHeading2="#ExperimentLab"
            link=""
            image="./images/metaverseHero.png"
          />
          <MetaverseContent />
        </HomeScreen>
      </MainLayout>
    </>
  );
};

export default Metaverse;
